import {
  useLayoutEffect,
  useState,
  useEffect,
  useCallback,
  useRef,
} from "react";
import DataGrid, {
  Column,
  Export,
  HeaderFilter,
  Pager,
  Paging,
  SearchPanel,
} from "devextreme-react/data-grid";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { assetService } from "../../../apis/apiServices/Asset";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRefresh } from "@fortawesome/free-solid-svg-icons";
import { SelectBox, Template, TextArea } from "devextreme-react";
import Modal from "react-modal";
import { vishwamApi } from "../../../apis/apiServices/VishwamApi";
import { askConfirmation, showResponseMessage } from "../../../helper/message";
import { IconWithTooltip, AssetSubStatus } from "../../../helper/fixcode";
import { Loader } from "../../Shared/PageLoader";

export default function NewAssetComponent(props) {
  const user = useSelector((state) => state.user.data);
  const navigate = useNavigate();
  const [state, setState] = useState({
    isSubmitted: false,
    isScrapped: false,
    isStatusUpdated: false,
    isAssignUserModalOpen: false,
    isAssignCustodianUserModalOpen: false,
    isScrappedAssetModalOpen: false,
    isUpdateAssetStatusModalOpen: false,
    scrappedRemark: "",
    assignDepartmentId: 0,
    assignDepartmentName: "",
    assignUserId: 0,
    assignUserName: "",
    rowData: null,
    assetNo: "",
    assetId: 0,
    custodian1DepartmentId: 0,
    custodian1DepartmentName: "",
    custodian2DepartmentId: 0,
    custodian2DepartmentName: "",
    custodian1UserId: 0,
    custodian1UserName: "",
    custodian2UserId: 0,
    custodian2UserName: "",
    assignTypeId: 0,
    assignTypeName: "",
    assetStatusId: 0,
    assetStatusName: "",
    isCompleteLoading: false,
    loadingMessage: "",
  });
  const [errors, setErrors] = useState({
    assignDepartmentValidation: "",
    custodian1DepartmentValidation: "",
    custodian2DepartmentValidation: "",
    assignUserValidation: "",
    custodian1UserValidation: "",
    custodian2UserValidation: "",
    scrappedRemarkValidation: "",
    assignTypeValidation: "",
    assetStatusValidation: "",
  });
  const [assetList, setAssetList] = useState([]);
  const [assetStatusDropdown, setAssetStatusDropdown] = useState([]);
  const [assignDepartmentDropdown, setAssignDepartmentDropdown] = useState([]);
  const [assignUserDropdown, setAssignUserDropdown] = useState([]);
  const [custodian1DepartmentDropdown, setCustodian1DepartmentDropdown] =
    useState([]);
  const [custodian2DepartmentDropdown, setCustodian2DepartmentDropdown] =
    useState([]);
  const [custodian1UserDropdown, setCustodian1UserDropdown] = useState([]);
  const [custodian2UserDropdown, setCustodian2UserDropdown] = useState([]);
  const [assignTypeDropdown, setAssignTypeDropdown] = useState([]);

  const refDataGrid = useRef(null);

  useLayoutEffect(() => {
    document.querySelector("#pageTitle").innerHTML = `Asset`;
  }, []);

  let isUseEffectRendered = false;
  useEffect(() => {
    const controller = new AbortController();
    try {
      if (isUseEffectRendered) {
        return;
      }
      fetchApiOnPageLoad();
      return () => {
        controller.abort();
        isUseEffectRendered = true;
      };
    } catch (error) {
      console.log(error);
    }
  }, []);

  const fetchApiOnPageLoad = useCallback(async () => {
    try {
      setState((prevState) => ({
        ...prevState,
        isCompleteLoading: true,
      }));

      await getAssetList(0);

      setState((prevState) => ({
        ...prevState,
        isCompleteLoading: false,
      }));
    } catch (error) {
      console.log(error);
      setState((prevState) => ({
        ...prevState,
        isCompleteLoading: false,
      }));
    }
  }, []);

  const getAssetList = async (assetId) => {
    try {
      //refDataGrid?.current?.instance?.beginCustomLoading();
      const Assetresponse = await assetService.getassetList(assetId);
      setAssetList(
        Assetresponse?.data.filter(
          (e) =>
            e.statusId === Number(AssetSubStatus.New) ||
            e.statusId === Number(AssetSubStatus.PendingForAcknowledgement)
        ) ?? []
      );
    } catch (error) {
      console.log(error);
    } finally {
      //refDataGrid?.current?.instance?.endCustomLoading();
    }
  };

  const getAssetStatusDropdown = async () => {
    try {
      const Assetresponse = await assetService.getStatusDropdown(1001);
      setAssetStatusDropdown(Assetresponse?.data ?? []);
    } catch (error) {
      console.log(error);
    }
  };

  const getAssignTypetDropdown = async () => {
    try {
      const assignTypeList = [
        { id: 1, name: "Department" },
        { id: 2, name: "User" },
      ];
      setAssignTypeDropdown(assignTypeList ?? []);
    } catch (error) {
      console.log(error);
    }
  };

  const getAssignDepartmentDropdown = async () => {
    try {
      const response = await vishwamApi.getDepartmentDropdown(user?.companyId);
      setAssignDepartmentDropdown(response?.data ?? []);
    } catch (error) {
      console.log(error);
    }
  };

  const getAssignedUserDropdown = async (assignDepartmentId) => {
    try {
      const response = await vishwamApi.getUserDrodpownByDepartmentd(
        assignDepartmentId,
        user?.companyId
      );
      setAssignUserDropdown(response?.data ?? []);
    } catch (error) {
      console.log(error);
    }
  };

  const getCustodian1DepartmentDropdown = async () => {
    try {
      const response = await vishwamApi.getDepartmentDropdown(user?.companyId);
      setCustodian1DepartmentDropdown(response?.data ?? []);
    } catch (error) {
      console.log(error);
    }
  };

  const getCustodian1UserDropdown = async (custodian1Department) => {
    try {
      const response = await vishwamApi.getUserDrodpownByDepartmentd(
        custodian1Department,
        user?.companyId
      );
      setCustodian1UserDropdown(response?.data ?? []);
    } catch (error) {
      console.log(error);
    }
  };

  const getCustodian2DepartmentDropdown = async () => {
    try {
      const response = await vishwamApi.getDepartmentDropdown(user?.companyId);
      setCustodian2DepartmentDropdown(response?.data ?? []);
    } catch (error) {
      console.log(error);
    }
  };

  const getCustodian2UserDropdown = async (custodian2Department) => {
    try {
      const response = await vishwamApi.getUserDrodpownByDepartmentd(
        custodian2Department,
        user?.companyId
      );
      setCustodian2UserDropdown(response?.data ?? []);
    } catch (error) {
      console.log(error);
    }
  };

  const isValidAssignUserData = () => {
    let isValid = true;
    try {
      let err = { ...errors };
      err.assignDepartmentValidation = "";
      err.assignUserValidation = "";
      err.assignTypeValidation = "";
      if (state.assignTypeId === 0) {
        err.assignTypeValidation = "Please select assign to.";
        isValid = false;
      }
      if (state.assignTypeId > 0 && state.assignDepartmentId === 0) {
        err.assignDepartmentValidation = "Please select department.";
        isValid = false;
      }
      if (state.assignTypeId === 2) {
        if (state.assignUserId === 0) {
          err.assignUserValidation = "Please select user.";
          isValid = false;
        }
      }
      setErrors(err);
    } catch (error) {
      console.log(error);
    }
    return isValid;
  };

  const handleOnAssignUserForAsset = async (e) => {
    e.preventDefault();
    try {
      if (isValidAssignUserData()) {
        let confirmationQuestion =
          state.assignTypeId === 2
            ? `<span style='font-size:16px;'> Are you sure want to ${
                state.rowData?.assignedId > 0 ? `unassign` : `assign`
              } user [<b>${state.assignUserName}</b>] from department [<b>${
                state.assignDepartmentName
              }</b>] for asset [<b>${state.rowData?.name} - (${
                state.assetNo
              })</b>]?</span>`
            : `<span style='font-size:16px;'> Are you sure want to ${
                state.rowData?.assignDepartmentId > 0 ? `unassign` : `assign`
              } department [<b>${
                state.assignDepartmentName
              }</b>] for asset [<b>${state.rowData?.name} - (${
                state.assetNo
              })</b>]?</span>`;
        let isConfirmed = await askConfirmation(
          confirmationQuestion,
          "Yes",
          "No"
        );
        if (!isConfirmed) return;
        setState((prev) => ({ ...prev, isSubmitted: true }));
        let body = {
          assetId: state.assetId,
          departmentId: state.assignDepartmentId,
          assignedUserId: state.assignUserId,
          userId: user?.userId,
          assignTypeId: state.assignTypeId,
        };
        const response = await assetService.assignUserForAsset(body);
        isConfirmed = await showResponseMessage(response);
        setState((prev) => ({ ...prev, isSubmitted: false }));
        if (response?.isSuccess) {
          handleOnCloseAssignUserModal();
          await getAssetList(0);
        }
      }
    } catch (error) {
      console.log(error);
      setState((prev) => ({ ...prev, isSubmitted: false }));
    }
  };

  const isValidAssignCustodianData = () => {
    let isValid = true;
    try {
      let err = { ...errors };
      err.custodian1DepartmentValidation = "";
      err.custodian2DepartmentValidation = "";
      err.custodian1UserValidation = "";
      err.custodian2UserValidation = "";
      if (state.custodian1DepartmentId === 0) {
        err.custodian1DepartmentValidation = "Please select department.";
        isValid = false;
      }
      if (state.custodian2DepartmentId === 0) {
        err.custodian2DepartmentValidation = "Please select department.";
        isValid = false;
      }
      if (state.custodian1UserId === 0) {
        err.custodian1UserValidation = "Please select custodian 1.";
        isValid = false;
      }
      if (state.custodian2UserId === 0) {
        err.custodian2UserValidation = "Please select custodian 2.";
        isValid = false;
      }
      setErrors(err);
    } catch (error) {
      console.log(error);
    }
    return isValid;
  };

  const handleOnAssignCustodianUsers = async (e) => {
    e.preventDefault();
    try {
      if (isValidAssignCustodianData()) {
        let confirmationQuestion = `<span style='font-size:16px;'> Are you sure want to ${
          state.rowData?.custodianUserId1 > 0 &&
          state.rowData?.custodianUserId2 > 0
            ? `update`
            : `add`
        } custodian 1 [<b>${
          state.custodian1UserName
        }</b>] from department [<b>${
          state.custodian1DepartmentName
        }</b>] and custodian 2 [<b>${
          state.custodian2UserName
        }</b>] from department [<b>${
          state.custodian2DepartmentName
        }</b>] for asset [<b>${state.rowData?.name} - (${
          state.assetNo
        })</b>]?</span>`;
        let isConfirmed = await askConfirmation(
          confirmationQuestion,
          "Yes",
          "No"
        );
        if (!isConfirmed) return;
        setState((prev) => ({ ...prev, isSubmitted: true }));
        let body = {
          assetId: state.assetId,
          custodian1DepartmentId: state.custodian1DepartmentId,
          custodian2DepartmentId: state.custodian2DepartmentId,
          custodian1UserId: state.custodian1UserId,
          custodian2UserId: state.custodian2UserId,
          userId: user?.userId,
        };
        const response = await assetService.assignCustodianUserForAsset(body);
        isConfirmed = await showResponseMessage(response);
        setState((prev) => ({ ...prev, isSubmitted: false }));
        if (response?.isSuccess) {
          handleOnCloseCustodianUsersModal();
          await getAssetList(0);
        }
      }
    } catch (error) {
      console.log(error);
      setState((prev) => ({ ...prev, isSubmitted: false }));
    }
  };

  const isValiScrappedData = () => {
    let isValid = true;
    try {
      let err = { ...errors };
      err.scrappedRemarkValidation = "";
      if (!state.scrappedRemark) {
        err.scrappedRemarkValidation = "Please enter remark.";
        isValid = false;
      }
      setErrors(err);
    } catch (error) {
      console.log(error);
    }
    return isValid;
  };

  const handleOnScrapAsset = async (e) => {
    e.preventDefault();
    try {
      if (isValiScrappedData()) {
        let confirmationQuestion = `<span style='font-size:16px;'>Are you sure want to scrap asset [<b>${state.rowData?.name} - (${state.assetNo})</b>]?</span>`;
        let isConfirmed = await askConfirmation(
          confirmationQuestion,
          "Yes",
          "No"
        );
        if (!isConfirmed) return;
        setState((prev) => ({ ...prev, isScrapped: true }));
        let body = {
          assetId: state.assetId,
          scrappedRemark: state.scrappedRemark,
          userId: user?.userId,
        };
        const response = await assetService.scrappedAsset(body);
        isConfirmed = await showResponseMessage(response);
        setState((prev) => ({ ...prev, isScrapped: false }));
        if (response?.isSuccess) {
          handleOnCloseScrappedAssetModal();
          await getAssetList(0);
        }
      }
    } catch (error) {
      console.log(error);
      setState((prev) => ({ ...prev, isScrapped: false }));
    }
  };

  const isValidAssetStatusData = () => {
    let isValid = true;
    try {
      let err = { ...errors };
      err.assetStatusValidation = "";
      if (state.assetStatusId === 0) {
        err.assetStatusValidation = "Please select status.";
        isValid = false;
      }
      setErrors(err);
    } catch (error) {
      console.log(error);
    }
    return isValid;
  };

  const handleOnUpateAssetStatus = async (e) => {
    e.preventDefault();
    try {
      if (isValidAssetStatusData()) {
        let confirmationQuestion = `<span style='font-size:16px;'>Are you sure want to update status to [<b>${state.assetStatusName}</b>] for asset [<b>${state.rowData?.name} - (${state.assetNo})</b>]?</span>`;
        let isConfirmed = await askConfirmation(
          confirmationQuestion,
          "Yes",
          "No"
        );
        if (!isConfirmed) return;
        setState((prev) => ({ ...prev, isStatusUpdated: true }));
        const response = await assetService.updateAssetStatus(
          state.assetId,
          state.assetStatusId,
          user?.userId
        );
        isConfirmed = await showResponseMessage(response);
        setState((prev) => ({ ...prev, isStatusUpdated: false }));
        if (response?.isSuccess) {
          handleOnCloseUpdateAssetStatusModal();
          await getAssetList(0);
        }
      }
    } catch (error) {
      console.log(error);
      setState((prev) => ({ ...prev, isStatusUpdated: false }));
    }
  };

  const handleOnOpenAssignUserModal = async (e, data) => {
    e.preventDefault();
    try {
      setState((prev) => ({
        ...prev,
        isAssignUserModalOpen: true,
        assetNo: data?.assetSerial,
        assetId: data?.assetId,
        rowData: data,
        assignUserId: data?.assignUserId,
        assignDepartmentId: data?.assignDepartmentId,
        assignDepartmentName: data?.assignDepartmentName,
        assignUserName: data?.assignUserName,
        assignTypeId: data?.assignTypeId,
        assignTypeName: data?.assignTypeName,
      }));
    } catch (error) {
      console.log(error);
    }
  };

  const handleOnOpenCustodianUsersModal = async (e, data) => {
    e.preventDefault();
    try {
      setState((prev) => ({
        ...prev,
        isAssignCustodianUserModalOpen: true,
        assetNo: data?.assetSerial,
        assetId: data?.assetId,
        rowData: data,
        custodian1UserId: data?.custodianUserId1,
        custodian1UserName: data?.custodianUser1Name,
        custodian2UserId: data?.custodianUserId2,
        custodian2UserName: data?.custodianUser2Name,
        custodian1DepartmentId: data?.custodian1DepartmentId,
        custodian2DepartmentId: data?.custodian2DepartmentId,
        custodian1DepartmentName: data?.custodian1DepartmentName,
        custodian2DepartmentName: data?.custodian2DepartmentName,
      }));
    } catch (error) {
      console.log(error);
    }
  };

  const handleOnOpenScrappedAssetModal = async (e, data) => {
    e.preventDefault();
    try {
      setState((prev) => ({
        ...prev,
        isScrappedAssetModalOpen: true,
        assetNo: data?.assetSerial,
        assetId: data?.assetId,
        rowData: data,
      }));
    } catch (error) {
      console.log(error);
    }
  };

  const handleOnOpenUpdateAssetStatusModal = async (e, data) => {
    e.preventDefault();
    try {
      setState((prev) => ({
        ...prev,
        isUpdateAssetStatusModalOpen: true,
        assetId: data?.assetId,
        assetStatusId: data?.statusId,
        assetStatusName: data?.statusName,
        assetNo: data?.assetSerial,
      }));
    } catch (error) {
      console.log(error);
    }
  };

  const handleOnCloseUpdateAssetStatusModal = () => {
    try {
      setState((prev) => ({
        ...prev,
        isUpdateAssetStatusModalOpen: false,
        assetId: 0,
        assetStatusId: 0,
        assetStatusName: "",
        assetNo: "",
      }));
      setAssetStatusDropdown([]);
    } catch (error) {
      console.log(error);
    }
  };

  const handleOnCloseAssignUserModal = () => {
    try {
      setState((prev) => ({
        ...prev,
        isAssignUserModalOpen: false,
        assignDepartmentId: 0,
        assignDepartmentName: "",
        assignUserId: 0,
        assignUserName: "",
        rowData: null,
        assetNo: "",
        assetId: 0,
        assignTypeId: 0,
        assignTypeName: "",
      }));
      setAssignDepartmentDropdown([]);
      setAssignUserDropdown([]);
      setAssignTypeDropdown([]);
    } catch (error) {
      console.log(error);
    }
  };

  const handleOnCloseCustodianUsersModal = () => {
    try {
      setState((prev) => ({
        ...prev,
        isAssignCustodianUserModalOpen: false,
        custodian1DepartmentId: 0,
        custodian1DepartmentName: "",
        custodian2DepartmentId: 0,
        custodian2DepartmentName: "",
        custodian1UserId: "",
        custodian1UserName: "",
        custodian2UserId: "",
        custodian2UserName: "",
        rowData: null,
        assetNo: "",
        assetId: 0,
      }));
      setCustodian1DepartmentDropdown([]);
      setCustodian2DepartmentDropdown([]);
      setCustodian1UserDropdown([]);
      setCustodian2UserDropdown([]);
    } catch (error) {
      console.log(error);
    }
  };

  const handleOnCloseScrappedAssetModal = () => {
    try {
      setState((prev) => ({
        ...prev,
        isScrappedAssetModalOpen: false,
        scrappedRemark: "",
        rowData: null,
        assetNo: "",
        assetId: 0,
      }));
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <div className="content">
        {/* <div className="card"> */}
        {/* <div className="card-body p-2"> */}
        {/* <div className="row pt-2"> */}
        {/* <div className="col-12 col-xl-2">
                <div className="form-group">
                  <DateBox
                    type="date"
                    //value={dateBoxValue}
                    placeholder="Date"
                  />
                </div>
              </div> */}
        {/* <div className="col-12 col-xl-2">
                <div className="form-group">
                  <SelectBox
                    // dataSource={assetList}
                    // displayExpr="AssetName"
                    // valueExpr="id"
                    placeholder="Vendor"
                  />
                </div>
              </div> */}
        {/* <div className="col-12 col-xl-2">
                <div className="form-group">
                  <SelectBox
                    // dataSource={assetList}
                    // displayExpr="AssetName"
                    // valueExpr="id"
                    placeholder="Category"
                  />
                </div>
              </div> */}
        {/* <div className="col-12 col-xl-2">
                <div className="form-group">
                  <SelectBox
                    // dataSource={assetList}
                    // displayExpr="AssetName"
                    // valueExpr="id"
                    placeholder="Location"
                  />
                </div>
              </div> */}
        {/* <div className="col-12 col-xl-2">
                <div className="form-group">
                  <SelectBox
                    // dataSource={assetList}
                    // displayExpr="AssetName"
                    // valueExpr="id"
                    placeholder="Status"
                  />
                </div>
              </div> */}
        {/* <div className="col-12 col-xl-2">
                <button className="btn btn-sm btn-primary" title="Filter">
                  <i className="fas fa-filter"></i> Filter
                </button>&nbsp;&nbsp;
                <button className="btn btn-sm btn-primary" title="Filter">
                  <i className="fas fa-filter"></i> Reset Filter
                </button>
              </div> */}
        {/* </div> */}
        {/* </div> */}
        {/* </div> */}
        {/* <div className="mb-2">
          <div className="row">
            <div className="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
              <div className="media assetscard">
                <i className="fas fa-boxes assets-icon bgone txtone mr-3"></i>
                <div className="media-body">
                  <p className="mb-0">All</p>
                  <h2 className="mt-0 txtone">500</h2>
                </div>
              </div>
            </div>
            <div className="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
              <div className="media assetscard">
                <i className="fas fa-check assets-icon bgtwo txttwo mr-3"></i>
                <div className="media-body">
                  <p className="mb-0">Good</p>
                  <h2 className="mt-0 txttwo">200</h2>
                </div>
              </div>
            </div>
            <div className="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
              <div className="media assetscard">
                <i className="fas fa-check assets-icon bgthree txtthree mr-3"></i>
                <div className="media-body">
                  <p className="mb-0">Fair</p>
                  <h2 className="mt-0 txtthree">200</h2>
                </div>
              </div>
            </div>
            <div className="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-2">
              <div className="media assetscard">
                <i className="fas fa-times assets-icon bgfour txtfour mr-3"></i>
                <div className="media-body">
                  <p className="mb-0">Poor</p>
                  <h2 className="mt-0 txtfour">230</h2>
                </div>
              </div>
            </div>
            <div className="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-2">
              <div className="media assetscard">
                <i className="fas fa-times assets-icon bgfive txtfive mr-3"></i>
                <div className="media-body">
                  <p className="mb-0">Bad</p>
                  <h2 className="mt-0 txtfive">230</h2>
                </div>
              </div>
            </div>
          </div>
        </div> */}
        <div className="card">
          <div className="card-body">
            <div className="row">
              <div className="col-12">
                <DataGrid
                  ref={refDataGrid}
                  keyExpr="assetId"
                  dataSource={assetList}
                  showColumnLines={false}
                  showRowLines={true}
                  showBorders={true}
                  allowColumnResizing={true}
                  allowColumnReordering={true}
                  columnAutoWidth={true}
                  onToolbarPreparing={(e) => {
                    e.toolbarOptions.items.unshift(
                      //   {
                      //     location: "before",
                      //     template: "toolbarAddTemplate",
                      //   },
                      {
                        location: "before",
                        template: "toolbarRefreshTemplate",
                      }
                    );
                  }}
                >
                  <Column
                    dataField="assetId"
                    width={28}
                    caption={""}
                    allowExporting={false}
                    allowFiltering={false}
                    allowSorting={false}
                    allowSearch={false}
                    cellRender={(cellData) => {
                      const idPrefix = `icon-${cellData?.data?.assetId}`;
                      return (
                        <>
                          <div style={{ display: "flex" }}>
                            {props?.featurePermission?.canEdit && (
                              <>
                                <span>
                                  <IconWithTooltip
                                    id={`${idPrefix}-edit`}
                                    className="iconify-size mr-1"
                                    title="Edit Asset"
                                    tooltip="Edit Asset"
                                    icon="solar:pen-line-duotone"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                      navigate("/AddAsset", {
                                        state: {
                                          stateData: cellData.data,
                                          sourceUrl: "OnBoarding",
                                        },
                                      });
                                    }}
                                  />
                                </span>

                                {/* <span>
                              <IconWithTooltip
                                id={`${idPrefix}-Add-Document`}
                                className="iconify-size mr-1"
                                title="Add Document"
                                tooltip="Add Document"
                                icon="flat-color-icons:folder"
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  navigate("/assetAttachment", {
                                    state: {
                                      stateData: cellData.data,
                                      assetId: cellData?.data?.assetId,
                                    },
                                  });
                                }}
                              />
                            </span>
                            <span>
                              <IconWithTooltip
                                id={`${idPrefix}-assign-user`}
                                className={`iconify-size mr-1 ${
                                  cellData.data?.assignUserId > 0
                                    ? "text-success"
                                    : "text-secondary"
                                }`}
                                title="Asset Allocation"
                                tooltip="Asset Allocation"
                                icon={`${
                                  cellData.data?.assignUserId > 0
                                    ? "mdi:user-check"
                                    : "mage:user-cross-fill"
                                }`}
                                style={{ cursor: "pointer" }}
                                onClick={async (e) => {
                                  await handleOnOpenAssignUserModal(
                                    e,
                                    cellData?.data
                                  );
                                }}
                              />
                            </span>
                            <span>
                              <IconWithTooltip
                                id={`${idPrefix}-custodian-user`}
                                className="iconify-size mr-1"
                                title="Assign Custodian User"
                                tooltip="Assign Custodian User"
                                icon="bxs:user"
                                style={{ cursor: "pointer" }}
                                onClick={async (e) => {
                                  await handleOnOpenCustodianUsersModal(
                                    e,
                                    cellData?.data
                                  );
                                }}
                              />
                            </span> */}
                                {/* <span>
                              <IconWithTooltip
                                id={`${idPrefix}-scrap`}
                                className="iconify-size mr-1"
                                title="Scrap Asset"
                                tooltip="Scrap Asset"
                                icon="fluent:delete-32-regular"
                                style={{ cursor: "pointer" }}
                                onClick={async (e) => {
                                  await handleOnOpenScrappedAssetModal(
                                    e,
                                    cellData?.data
                                  );
                                }}
                              />
                            </span> */}
                                {/* <span>
                              <IconWithTooltip
                                id={`${idPrefix}-switch`}
                                className="iconify-size mr-1"
                                title="Update Asset Status"
                                tooltip="Update Asset Status"
                                icon="stash:image-switch"
                                style={{ cursor: "pointer" }}
                                onClick={async (e) => {
                                  await handleOnOpenUpdateAssetStatusModal(
                                    e,
                                    cellData?.data
                                  );
                                }}
                              />
                            </span> */}
                              </>
                            )}
                          </div>
                        </>
                      );
                    }}
                  />
                  <Column
                    dataField="assetSerial"
                    caption="Asset ID"
                    allowFiltering={false}
                    allowSearch={true}
                    allowSorting={true}
                  />
                  <Column
                    dataField="assetRequestNo"
                    caption="Asset Request No"
                    allowFiltering={false}
                    allowSearch={true}
                    allowSorting={true}
                  />
                  <Column
                    dataField="name"
                    caption="Asset Name"
                    allowFiltering={false}
                    allowSearch={true}
                    allowSorting={true}
                    cellRender={(data) => {
                      return (
                        <>
                          <span>{data?.data?.name ?? ""}</span>
                          {data?.data?.assetDesc && (
                            <>
                              <br />
                              <div
                                style={{ color: "#b1b1b1", fontSize: "11px" }}
                              >
                                {data?.data?.assetDesc ?? ""}
                              </div>
                            </>
                          )}
                        </>
                      );
                    }}
                  />
                  <Column
                    dataField="groupName"
                    caption="Group"
                    allowFiltering={false}
                    allowSearch={true}
                    allowSorting={true}
                  />
                  <Column
                    dataField="categoryName"
                    caption="Category"
                    allowFiltering={false}
                    allowSearch={true}
                    allowSorting={true}
                  />
                  <Column
                    dataField="subCategoryName"
                    caption="Sub Category"
                    allowFiltering={false}
                    allowSearch={true}
                    allowSorting={true}
                  />
                  <Column
                    dataField="projectName"
                    caption="Asset Site / Location"
                    allowFiltering={false}
                    allowSearch={true}
                    allowSorting={true}
                    cellRender={(data) => {
                      return (
                        <>
                          <span>{data?.data?.projectName ?? ""}</span>
                          {data?.data?.assetLocationName && (
                            <>
                              <br />
                              <div
                                style={{ color: "#b1b1b1", fontSize: "11px" }}
                              >
                                {data?.data?.assetLocationName ?? ""}
                              </div>
                            </>
                          )}
                        </>
                      );
                    }}
                  />
                  <Column
                    dataField="statusName"
                    caption="Status"
                    allowFiltering={false}
                    allowSearch={true}
                    allowSorting={true}
                    cellRender={(data) => {
                      let textColorCss = "";
                      switch (data?.data?.statusId) {
                        case 10001:
                          textColorCss = "text-green";
                          break;
                        case 10003:
                          textColorCss = "text-orange";
                          break;
                        case 10013:
                          textColorCss = "text-danger";
                          break;
                        case 10002:
                          textColorCss = "text-yellow";
                          break;
                        case 10005:
                          textColorCss = "text-grey";
                          break;
                      }
                      return (
                        <>
                          <span className={textColorCss}>
                            {data?.data?.statusName}
                          </span>
                        </>
                      );
                    }}
                  />
                  <Column
                    dataField="vseFleetId"
                    caption="VSE Asset Id"
                    allowFiltering={false}
                    allowSearch={true}
                    allowSorting={true}
                  />
                  <Column
                    dataField="erpFleetId"
                    caption="SAP/ERP Asset Id"
                    allowFiltering={false}
                    allowSearch={true}
                    allowSorting={true}
                  />
                  <Column
                    dataField="custodianUser1Name"
                    caption="Custodian 1"
                    allowFiltering={false}
                    allowSearch={true}
                    allowSorting={true}
                    cellRender={(data) => {
                      if (data?.data?.custodianUser1Name) {
                        return (
                          <>
                            <span>{data?.data?.custodianUser1Name ?? ""}</span>
                            {data?.data?.custodian1DepartmentName && (
                              <>
                                <br />
                                <div
                                  style={{ color: "#b1b1b1", fontSize: "11px" }}
                                >
                                  {data?.data?.custodian1DepartmentName ?? ""}
                                </div>
                              </>
                            )}
                          </>
                        );
                      } else {
                        return "";
                      }
                    }}
                  />
                  <Column
                    dataField="custodianUser2Name"
                    caption="Custodian 2"
                    allowFiltering={false}
                    allowSearch={true}
                    allowSorting={true}
                    cellRender={(data) => {
                      if (data?.data?.custodianUser2Name) {
                        return (
                          <>
                            <span>{data?.data?.custodianUser2Name ?? ""}</span>
                            {data?.data?.custodian2DepartmentName && (
                              <>
                                <br />
                                <div
                                  style={{ color: "#b1b1b1", fontSize: "11px" }}
                                >
                                  {data?.data?.custodian2DepartmentName ?? ""}
                                </div>
                              </>
                            )}
                          </>
                        );
                      } else {
                        return "";
                      }
                    }}
                  />
                  <Column
                    dataField="custodianUser3Name"
                    caption="Custodian 3"
                    allowFiltering={false}
                    allowSearch={true}
                    allowSorting={true}
                    cellRender={(data) => {
                      if (data?.data?.custodianUser3Name) {
                        return (
                          <>
                            <span>{data?.data?.custodianUser3Name ?? ""}</span>
                            {data?.data?.custodian3DepartmentName && (
                              <>
                                <br />
                                <div
                                  style={{ color: "#b1b1b1", fontSize: "11px" }}
                                >
                                  {data?.data?.custodian3DepartmentName ?? ""}
                                </div>
                              </>
                            )}
                          </>
                        );
                      } else {
                        return "";
                      }
                    }}
                  />
                  <Column
                    dataField="assignDepartmentName"
                    caption="Assign To"
                    allowFiltering={false}
                    allowSearch={true}
                    allowSorting={true}
                    cellRender={(data) => {
                      if (data?.data?.assignDepartmentName) {
                        return (
                          <>
                            <span>
                              {data?.data?.assignDepartmentName ?? ""}
                            </span>
                            {data?.data?.assignUserId > 0 && (
                              <>
                                <br />
                                <div
                                  style={{ color: "#b1b1b1", fontSize: "11px" }}
                                >
                                  {data?.data?.assignUserName ?? ""}
                                </div>
                              </>
                            )}
                          </>
                        );
                      } else {
                        return "";
                      }
                    }}
                  />

                  {/* <Template
                    name="toolbarAddTemplate"
                    render={() => {
                      return (
                        <>
                          <button
                            className="btn btn-primary btn-sm mr-1"
                            onClick={() => {
                              navigate("/addAsset");
                            }}
                            title="Add"
                          >
                            <i className="fas fa-plus"></i>&nbsp;&nbsp;Add
                          </button>
                        </>
                      );
                    }}
                  /> */}
                  <Template
                    name="toolbarRefreshTemplate"
                    render={() => {
                      return (
                        <>
                          <button
                            className="btn btn-outline-primary btn-sm"
                            onClick={() => getAssetList(0)}
                            title="Refresh"
                          >
                            <FontAwesomeIcon icon={faRefresh} /> Refresh
                          </button>
                        </>
                      );
                    }}
                  />
                  <HeaderFilter visible={false} />
                  <SearchPanel
                    visible={true}
                    highlightCaseSensitive={true}
                    width={240}
                    placeholder="Search..."
                  />
                  <Paging defaultPageSize={15} />
                  <Pager displayMode="compact" showInfo={true} visible={true} />
                  <Export enabled={true} fileName="Asset" />
                </DataGrid>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* For Assigning User */}
      <Modal
        ariaHideApp={false}
        isOpen={state.isAssignUserModalOpen}
        onAfterOpen={async () => {
          await getAssignDepartmentDropdown();
          await getAssignTypetDropdown();
          await getAssignedUserDropdown(state.assignDepartmentId);
          let err = { ...errors };
          err.assignDepartmentValidation = "";
          err.assignUserValidation = "";
          err.assignTypeValidation = "";
          setErrors(err);
        }}
        className={"react-modal custom-modal-large"}
        shouldCloseOnOverlayClick={false}
        contentLabel="Asset Allocation For Asset"
      >
        <div className="modal-header">
          <h6 className="modal-title">
            {`Asset Allocation For [${state.rowData?.name} - (${state.assetNo})]`}
          </h6>
          <button
            type="button"
            className="close"
            onClick={() => {
              handleOnCloseAssignUserModal();
            }}
          >
            <span aria-hidden="true">x</span>
          </button>
        </div>
        <div className="modal-body">
          <div className="row">
            <div className="col-12 col-lg-4">
              <div className="form-group mb-2">
                <label>Asset Serial #</label>
                <p className="mb-0 textinfo">{state.assetNo}</p>
              </div>
            </div>
            <div className="col-12 col-lg-4">
              <div className="form-group mb-2">
                <label>Category</label>
                <p className="mb-0 textinfo">{state.rowData?.categoryName}</p>
              </div>
            </div>
            <div className="col-12 col-lg-4">
              <div className="form-group mb-2">
                <label>Sub Category</label>
                <p className="mb-0 textinfo">
                  {state.rowData?.subCategoryName}
                </p>
              </div>
            </div>
          </div>
          <div className="row">
            <div
              className={`col-12 col-lg-${
                state.assignTypeId === 1 ? "6" : "4"
              }`}
            >
              <div className="form-group mb-2">
                <label>
                  Assign To&nbsp;<span className="text-danger">*</span>
                </label>
                <SelectBox
                  dataSource={assignTypeDropdown}
                  className="basic-multi-select"
                  classNamePrefix="select"
                  placeholder="Select assign type"
                  name="assignTypeDropdown"
                  displayExpr="name"
                  valueExpr="id"
                  value={state.assignTypeId}
                  defaultValue={state.assignTypeId}
                  showClearButton={true}
                  disabled={false}
                  readOnly={
                    state.rowData?.assignDepartmentId > 0 ||
                    state.rowData?.assignUserId > 0
                      ? true
                      : false
                  }
                  searchEnabled={true}
                  onSelectionChanged={(e) => {
                    let err = { ...errors };
                    err.assignTypeValidation = "";
                    setErrors(err);
                    setState((prev) => ({
                      ...prev,
                      assignTypeId: e?.selectedItem?.id ?? 0,
                      assignTypeName: e?.selectedItem?.name ?? "",
                      assignDepartmentId: 0,
                      assignDepartmentName: "",
                      assignUserId: 0,
                      assignUserName: "",
                    }));
                  }}
                />
                {errors.assignTypeValidation && (
                  <div className="text-danger">
                    {errors.assignTypeValidation}
                  </div>
                )}
              </div>
            </div>
            {state.assignTypeId > 0 && (
              <>
                <div
                  className={`col-12 col-lg-${
                    state.assignTypeId === 1 ? "6" : "4"
                  }`}
                >
                  <div className="form-group mb-2">
                    <label>
                      Department
                      {state.assignDepartmentId === 0 && (
                        <>
                          &nbsp;<span className="text-danger">*</span>
                        </>
                      )}
                    </label>
                    <SelectBox
                      dataSource={assignDepartmentDropdown}
                      className="basic-multi-select"
                      classNamePrefix="select"
                      placeholder="Select department"
                      name="assignDepartmentDropdown"
                      displayExpr="departmentName"
                      valueExpr="id"
                      value={state.assignDepartmentId}
                      defaultValue={state.assignDepartmentId}
                      showClearButton={true}
                      readOnly={
                        state.rowData?.assignDepartmentId > 0 ? true : false
                      }
                      searchEnabled={true}
                      onSelectionChanged={async (e) => {
                        let err = { ...errors };
                        err.assignDepartmentValidation = "";
                        setErrors(err);
                        setState((prev) => ({
                          ...prev,
                          assignDepartmentId: e?.selectedItem?.id ?? 0,
                          assignDepartmentName:
                            e?.selectedItem?.departmentName ?? "",
                          assignUserId: 0,
                          assignUserName: "",
                        }));
                        setAssignUserDropdown([]);
                        if (e?.selectedItem?.id > 0) {
                          await getAssignedUserDropdown(e?.selectedItem?.id);
                        }
                      }}
                    />
                    {errors.assignDepartmentValidation && (
                      <div className="text-danger">
                        {errors.assignDepartmentValidation}
                      </div>
                    )}
                  </div>
                </div>
              </>
            )}
            {state.assignTypeId === 2 && (
              <>
                <div className="col-12 col-lg-4">
                  <div className="form-group mb-2">
                    <label>
                      User
                      {state.assignUserId === 0 && (
                        <>
                          &nbsp;<span className="text-danger">*</span>
                        </>
                      )}
                    </label>
                    <SelectBox
                      dataSource={assignUserDropdown}
                      className="basic-multi-select"
                      classNamePrefix="select"
                      placeholder="Select user"
                      name="assignUserDropdown"
                      displayExpr="name"
                      valueExpr="id"
                      value={state.assignUserId}
                      defaultValue={state.assignUserId}
                      showClearButton={true}
                      readOnly={state.rowData?.assignUserId > 0 ? true : false}
                      searchEnabled={true}
                      onSelectionChanged={async (e) => {
                        let err = { ...errors };
                        err.assignUserValidation = "";
                        setErrors(err);
                        setState((prev) => ({
                          ...prev,
                          assignUserId: e?.selectedItem?.id ?? 0,
                          assignUserName: e?.selectedItem?.name ?? "",
                        }));
                      }}
                    />
                    {errors.assignUserValidation && (
                      <div className="text-danger">
                        {errors.assignUserValidation}
                      </div>
                    )}
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-primary btn-sm"
            onClick={async (e) => {
              await handleOnAssignUserForAsset(e);
            }}
            disabled={state.isSubmitted}
          >
            <span>
              <i
                className={`fas fa-${
                  state.isSubmitted
                    ? `spinner fa-spin`
                    : `${
                        state.rowData?.assignUserId > 0 ||
                        state.rowData?.assignDepartmentId > 0
                          ? "times"
                          : "check"
                      }`
                }`}
              />
              &nbsp;&nbsp;
              {state.rowData?.assignUserId > 0 ||
              state.rowData?.assignDepartmentId > 0
                ? "UnAssign"
                : "Assign"}
            </span>
          </button>
          &nbsp;&nbsp;
          <button
            type="button"
            className="btn btn-outline-primary btn-sm"
            title="Cancel"
            onClick={() => {
              handleOnCloseAssignUserModal();
            }}
          >
            <i className="fas fa-times"></i>&nbsp;&nbsp;Cancel
          </button>
        </div>
      </Modal>

      {/* For Assigning Custodian Users */}
      <Modal
        ariaHideApp={false}
        isOpen={state.isAssignCustodianUserModalOpen}
        onAfterOpen={async () => {
          await getCustodian1DepartmentDropdown();
          await getCustodian2DepartmentDropdown();
          await getCustodian1UserDropdown(state.custodian1DepartmentId);
          await getCustodian2UserDropdown(state.custodian2DepartmentId);
          let err = { ...errors };
          err.custodian1DepartmentValidation = "";
          err.custodian2DepartmentValidation = "";
          err.custodian1UserValidation = "";
          err.custodian2UserValidation = "";
          setErrors(err);
        }}
        className={"react-modal custom-modal-large"}
        shouldCloseOnOverlayClick={false}
        contentLabel="Assign Custodian Users"
      >
        <div className="modal-header">
          <h6 className="modal-title">{`${
            state.rowData?.custodianUserId1 > 0 &&
            state.rowData?.custodianUserId2 > 0
              ? `Update Custodian Users For Asset Name [${state.rowData?.name} - (${state.assetNo})]`
              : `Add Custodian Users For Asset Name [${state.rowData?.name} - (${state.assetNo})]`
          }`}</h6>
          <button
            type="button"
            className="close"
            onClick={() => {
              handleOnCloseCustodianUsersModal();
            }}
          >
            <span aria-hidden="true">x</span>
          </button>
        </div>
        <div className="modal-body">
          <div className="row">
            <div className="col-12 col-lg-4">
              <div className="form-group mb-2">
                <label>Asset Serial #</label>
                <p className="mb-0 textinfo">{state.assetNo}</p>
              </div>
            </div>
            <div className="col-12 col-lg-4">
              <div className="form-group mb-2">
                <label>Category</label>
                <p className="mb-0 textinfo">{state.rowData?.categoryName}</p>
              </div>
            </div>
            <div className="col-12 col-lg-4">
              <div className="form-group mb-2">
                <label>Sub Category</label>
                <p className="mb-0 textinfo">
                  {state.rowData?.subCategoryName}
                </p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12 col-lg-6">
              <div className="form-group mb-2">
                <label>
                  Department&nbsp;<span className="text-danger">*</span>
                </label>
                <SelectBox
                  dataSource={
                    custodian1DepartmentDropdown?.filter(
                      (f) => f.id !== state.custodian2DepartmentId
                    ) || []
                  }
                  className="basic-multi-select"
                  classNamePrefix="select"
                  placeholder="Select department"
                  name="custodian1DepartmentDropdown"
                  displayExpr="departmentName"
                  valueExpr="id"
                  value={state.custodian1DepartmentId}
                  defaultValue={state.custodian1DepartmentId}
                  showClearButton={true}
                  disabled={false}
                  searchEnabled={true}
                  onSelectionChanged={async (e) => {
                    let err = { ...errors };
                    err.custodian1DepartmentValidation = "";
                    setErrors(err);
                    setState((prev) => ({
                      ...prev,
                      custodian1DepartmentId: e?.selectedItem?.id ?? 0,
                      custodian1DepartmentName:
                        e?.selectedItem?.departmentName ?? "",
                      custodian1UserId: 0,
                      custodian1UserName: "",
                    }));
                    setCustodian1UserDropdown([]);
                    if (e?.selectedItem?.id > 0) {
                      await getCustodian1UserDropdown(e?.selectedItem?.id);
                    }
                  }}
                />
                {errors.custodian1DepartmentValidation && (
                  <div className="text-danger">
                    {errors.custodian1DepartmentValidation}
                  </div>
                )}
              </div>
            </div>
            <div className="col-12 col-lg-6">
              <div className="form-group mb-2">
                <label>
                  Custodian 1&nbsp;<span className="text-danger">*</span>
                </label>
                <SelectBox
                  dataSource={
                    custodian1UserDropdown?.filter(
                      (f) => f.id !== state.custodian2UserId
                    ) || []
                  }
                  className="basic-multi-select"
                  classNamePrefix="select"
                  placeholder="Select custodian 1"
                  name="custodian1UserDropdown"
                  displayExpr="name"
                  valueExpr="id"
                  value={state.custodian1UserId}
                  defaultValue={state.custodian1UserId}
                  showClearButton={true}
                  readOnly={false}
                  disabled={false}
                  searchEnabled={true}
                  onSelectionChanged={async (e) => {
                    let err = { ...errors };
                    err.custodian1UserValidation = "";
                    setErrors(err);
                    setState((prev) => ({
                      ...prev,
                      custodian1UserId: e?.selectedItem?.id ?? 0,
                      custodian1UserName: e?.selectedItem?.name ?? "",
                    }));
                  }}
                />
                {errors.custodian1UserValidation && (
                  <div className="text-danger">
                    {errors.custodian1UserValidation}
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12 col-lg-6">
              <div className="form-group mb-2">
                <label>
                  Department&nbsp;<span className="text-danger">*</span>
                </label>
                <SelectBox
                  dataSource={
                    custodian2DepartmentDropdown?.filter(
                      (f) => f.id !== state.custodian1DepartmentId
                    ) || []
                  }
                  className="basic-multi-select"
                  classNamePrefix="select"
                  placeholder="Select department"
                  name="custodian2DepartmentDropdown"
                  displayExpr="departmentName"
                  valueExpr="id"
                  value={state.custodian2DepartmentId}
                  defaultValue={state.custodian2DepartmentId}
                  showClearButton={true}
                  disabled={false}
                  searchEnabled={true}
                  onSelectionChanged={async (e) => {
                    let err = { ...errors };
                    err.custodian2DepartmentValidation = "";
                    setErrors(err);
                    setState((prev) => ({
                      ...prev,
                      custodian2DepartmentId: e?.selectedItem?.id ?? 0,
                      custodian2DepartmentName:
                        e?.selectedItem?.departmentName ?? "",
                      custodian2UserId: 0,
                      custodian2UserName: "",
                    }));
                    setCustodian2UserDropdown([]);
                    if (e?.selectedItem?.id > 0) {
                      await getCustodian2UserDropdown(e?.selectedItem?.id);
                    }
                  }}
                />
                {errors.custodian2DepartmentValidation && (
                  <div className="text-danger">
                    {errors.custodian2DepartmentValidation}
                  </div>
                )}
              </div>
            </div>
            <div className="col-12 col-lg-6">
              <div className="form-group mb-2">
                <label>
                  Custodian 2&nbsp;<span className="text-danger">*</span>
                </label>
                <SelectBox
                  dataSource={
                    custodian2UserDropdown?.filter(
                      (f) => f.id !== state.custodian1UserId
                    ) || []
                  }
                  className="basic-multi-select"
                  classNamePrefix="select"
                  placeholder="Select custodian 2"
                  name="custodian2UserDropdown"
                  displayExpr="name"
                  valueExpr="id"
                  value={state.custodian2UserId}
                  defaultValue={state.custodian2UserId}
                  showClearButton={true}
                  readOnly={false}
                  disabled={false}
                  searchEnabled={true}
                  onSelectionChanged={async (e) => {
                    let err = { ...errors };
                    err.custodian2UserValidation = "";
                    setErrors(err);
                    setState((prev) => ({
                      ...prev,
                      custodian2UserId: e?.selectedItem?.id ?? 0,
                      custodian2UserName: e?.selectedItem?.name ?? "",
                    }));
                  }}
                />
                {errors.custodian2UserValidation && (
                  <div className="text-danger">
                    {errors.custodian2UserValidation}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-primary btn-sm"
            onClick={async (e) => {
              await handleOnAssignCustodianUsers(e);
            }}
            disabled={state.isSubmitted}
          >
            <span title="Submit">
              <i
                className={`fas fa-${
                  state.isSubmitted ? "spinner fa-spin" : "check"
                }`}
              />
              &nbsp;&nbsp;Submit
            </span>
          </button>
          &nbsp;&nbsp;
          <button
            type="button"
            className="btn btn-outline-primary btn-sm"
            title="Cancel"
            onClick={() => {
              handleOnCloseCustodianUsersModal();
            }}
          >
            <i className="fas fa-times"></i>&nbsp;&nbsp;Cancel
          </button>
        </div>
      </Modal>

      {/* For Scrapping Asset */}
      <Modal
        ariaHideApp={false}
        isOpen={state.isScrappedAssetModalOpen}
        onAfterOpen={async () => {
          let err = { ...errors };
          err.scrappedRemarkValidation = "";
          setErrors(err);
        }}
        className={"react-modal custom-modal-small"}
        shouldCloseOnOverlayClick={false}
        contentLabel="Assign User"
      >
        <div className="modal-header">
          <h6 className="modal-title">{`Scrap Asset No [${state.assetNo}]`}</h6>
          <button
            type="button"
            className="close"
            onClick={() => {
              handleOnCloseScrappedAssetModal();
            }}
          >
            <span aria-hidden="true">x</span>
          </button>
        </div>
        <div className="modal-body">
          <div className="row">
            <div className="col-12 col-lg-12">
              <div className="form-group mb-2">
                <label>
                  Remark&nbsp;<span className="text-danger">*</span>
                </label>
                <TextArea
                  className="form-control"
                  placeholder="Enter remark"
                  showClearButton={true}
                  valueChangeEvent="keyup"
                  value={state.scrappedRemark}
                  onValueChanged={(e) => {
                    let err = { ...errors };
                    err.scrappedRemarkValidation = "";
                    setErrors(err);
                    setState((prev) => ({
                      ...prev,
                      scrappedRemark: e.value,
                    }));
                  }}
                />
                {errors.scrappedRemarkValidation && (
                  <div className="text-danger">
                    {errors.scrappedRemarkValidation}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-primary btn-sm"
            onClick={async (e) => {
              await handleOnScrapAsset(e);
            }}
            disabled={state.isScrapped}
          >
            <span title="Scrap">
              <i
                className={`fas fa-${
                  state.isScrapped ? "spinner fa-spin" : "check"
                }`}
              />
              &nbsp;&nbsp;Scrap
            </span>
          </button>
          &nbsp;&nbsp;
          <button
            type="button"
            className="btn btn-outline-primary btn-sm"
            title="Cancel"
            onClick={() => {
              handleOnCloseScrappedAssetModal();
            }}
          >
            <i className="fas fa-times"></i>&nbsp;&nbsp;Cancel
          </button>
        </div>
      </Modal>

      {/* For Updating Asset Status */}
      <Modal
        ariaHideApp={false}
        isOpen={state.isUpdateAssetStatusModalOpen}
        onAfterOpen={async () => {
          let err = { ...errors };
          err.assetStatusValidation = "";
          setErrors(err);
          await getAssetStatusDropdown();
        }}
        className={"react-modal custom-modal-small"}
        shouldCloseOnOverlayClick={false}
        contentLabel="Update Asset Status"
      >
        <div className="modal-header">
          <h6 className="modal-title">{`Update Status For Asset No [${state.assetNo}]`}</h6>
          <button
            type="button"
            className="close"
            onClick={() => {
              handleOnCloseUpdateAssetStatusModal();
            }}
          >
            <span aria-hidden="true">x</span>
          </button>
        </div>
        <div className="modal-body">
          <div className="row">
            <div className="col-12 col-lg-12">
              <div className="form-group mb-2">
                <label>
                  Status&nbsp;<span className="text-danger">*</span>
                </label>
                <SelectBox
                  dataSource={assetStatusDropdown}
                  className="basic-multi-select"
                  classNamePrefix="select"
                  placeholder="Select status"
                  name="assetStatusDropdown"
                  displayExpr="name"
                  valueExpr="id"
                  value={state.assetStatusId}
                  defaultValue={state.assetStatusId}
                  showClearButton={true}
                  disabled={false}
                  searchEnabled={true}
                  onSelectionChanged={async (e) => {
                    let err = { ...errors };
                    err.assetStatusValidation = "";
                    setErrors(err);
                    setState((prev) => ({
                      ...prev,
                      assetStatusId: e?.selectedItem?.id ?? 0,
                      assetStatusName: e?.selectedItem?.name ?? "",
                    }));
                  }}
                />
                {errors.assetStatusValidation && (
                  <div className="text-danger">
                    {errors.assetStatusValidation}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-primary btn-sm"
            onClick={async (e) => {
              await handleOnUpateAssetStatus(e);
            }}
            disabled={state.isStatusUpdated}
          >
            <span title="Submit">
              <i
                className={`fas fa-${
                  state.isStatusUpdated ? "spinner fa-spin" : "check"
                }`}
              />
              &nbsp;&nbsp;Submit
            </span>
          </button>
          &nbsp;&nbsp;
          <button
            type="button"
            className="btn btn-outline-primary btn-sm"
            title="Cancel"
            onClick={() => {
              handleOnCloseUpdateAssetStatusModal();
            }}
          >
            <i className="fas fa-times"></i>&nbsp;&nbsp;Cancel
          </button>
        </div>
      </Modal>

      {state.isCompleteLoading && (
        <Loader loadingMessage={state.loadingMessage} />
      )}
    </>
  );
}
